import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';

@Directive({
  selector: '[onReady]',
  standalone: true
})
export class OnReadyDirective implements AfterViewInit, OnDestroy {
  @Output('autoBind') autoBind = new EventEmitter<HTMLElement>();

  // Permet de forcer le rebind depuis le composant
  @Input() set onReadyTrigger(_: any) {
    this.emit();
  }

  private element!: HTMLElement;
  private cleanupFns: (() => void)[] = [];

  constructor(private el: ElementRef) {
    // On attend ngAfterViewInit pour accéder à nativeElement
  }

  ngAfterViewInit(): void {
    this.element = this.el.nativeElement as HTMLElement;
    this.emit();
    // this.setupValueInterceptor();
    // this.listenToEvents();
  }

  private emit(): void {
    if (this.element) {
      this.autoBind.emit(this.element);
    }
  }

  // --- Intercepte element.value = '...' (même en JS pur) ---
  private setupValueInterceptor(): void {
    if (!('value' in this.element)) return;

    const proto = Object.getPrototypeOf(this.element);
    const descriptor = Object.getOwnPropertyDescriptor(proto, 'value')
      || Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

    if (!descriptor?.set) return;

    const originalSet = descriptor.set.bind(this.element);
    const directive = this;

    const newSet = function (this: any, value: any) {
      originalSet(value);
      setTimeout(() => directive.emit(), 0);
    };

    // Remplace le setter
    try {
      Object.defineProperty(this.element, 'value', {
        ...descriptor,
        set: newSet
      });

      // Nettoyage : restaurer l'original
      this.cleanupFns.push(() => {
        try {
          Object.defineProperty(this.element, 'value', descriptor);
        } catch { }
      });
    } catch (e) {
      // Silently fail (rare)
    }
  }

  // --- Écoute les événements utilisateur ---
  private listenToEvents(): void {
    const events = ['input', 'change', 'focusin', 'click', 'keydown'];
    const handler = () => this.emit();

    events.forEach(ev => {
      this.element.addEventListener(ev, handler, { passive: true });
    });

    this.cleanupFns.push(() => {
      events.forEach(ev => {
        this.element.removeEventListener(ev, handler);
      });
    });
  }

  ngOnDestroy(): void {
    this.cleanupFns.forEach(fn => fn());
    this.cleanupFns = [];
  }
}